// jQuery UI dialog's documentation (options, events, methods, theming): https://api.jqueryui.com/dialog/

/**
 **********************************************
 * Helpers to customize dialogs
 **********************************************
 */

// Enables both <button> and <a> when users close dialogs or alerts
const enableUserActions = () => {
    const buttons = document.getElementsByTagName('button')
    const buttonLinks = document.getElementsByClassName('disabled')
    if (buttons) {
        Array.from(buttons).forEach((button) => button.disabled = false)
    }
    if (buttonLinks) {
        Array.from(buttonLinks).forEach((a) => a.classList.remove('disabled'))
    }
}

// Custom dialog class according to use case
const setDialogClass = (type) => {
    return `ui-dialog__${type}`
}

// Alerts in Dialogs
// // Available types: success, error, warn, info
// // Available sizes: alert-medium, alert-large (Leave size as empty string if it's a small alert -one line of text-)
const renderAlert = (type, size, message) => {
    return `<div class="ui-dialog__alert ${size} alert--${type}">
                <img
                    class="ui-dialog__alert-image"
                    src="/images/default/${type}.png"
                    alt="${type}"
                />
                <div class="ui-dialog__alert-text">
                    ${message}
                </div>
            </div>`;
}

/**
 **********************************************
 * JS Helper functions
 **********************************************
 */

// Returns length for array-like values or the number of own enumerable string keyed properties for objects
const itemSize = item => item.constructor === Object ? Object.keys(item).length : item.length;

// Creates an array excluding all given values
const without = (arr, ...args) => arr.filter(item => !args.includes(item));

// Creates an array of unique values, in order, from all given arrays
const union = (arr, ...args) => [...new Set(arr.concat(...args))];


/**
 **********************************************
 * RELEASE ERRORS DIALOG
 **********************************************
 */
ReleaseErrorsDialog = function (_settings) {
    this.create(_settings || {});
};
ReleaseErrorsDialog.prototype = {
    create: function (_settings) {
        this.title = _settings.title ? _settings.title : _T('release_errors_dialog_title');
        this.channelCache = _settings.channelCache;
        this.releaseCache = _settings.releaseCache;
        this.trackCache = _settings.trackCache;
        this.artistCache = _settings.artistCache;
        this.settings = _settings;
        this.valid = false;
        this.in_form_validation = _settings.in_form_validation ? _settings.in_form_validation : false;
    },

    isValid: function () {
        return this.valid;
    },

    onData: function (_data) {
        this.valid = true;
        if (_data === true || itemSize(_data) === 0) {
            this.data = {};
            return;
        }
        if (!Array.isArray(_data)) {
            _data = [_data];
        }
        this.data = _data;

        let releases = [];
        let channels = [];
        let tracks = [];
        let artists = [];

        for (let i in _data) {
            const release = _data[i];
            releases.push(release.release_id);
            this.valid = this.valid && (itemSize(release.errors) === 0);

            for (let j in release.errors) {
                const per_channel = release.errors[j];
                channels.push(per_channel.channel_id);
                if (Array.isArray(per_channel.tracks)) {
                    for (let k in per_channel.tracks) {
                        tracks.push(per_channel.tracks[k].track_id);
                    }
                }
                if (Array.isArray(per_channel.artists)) {
                    for (let l in per_channel.artists) {
                        artists.push(per_channel.artists[l].artist_id);
                    }
                }
            }
            channels = channels.concat(release.valid);
        }
        this.releaseCache.fetch({async: false, add: true, ids: releases});
        this.channelCache.fetch({async: false, add: true, ids: without(channels, 'base')});
        this.trackCache.fetch({async: false, add: true, ids: tracks});
        this.artistCache.fetch({async: false, add: true, ids: artists});
    },

    render: function () {
        this.settings.container.html('');
        const self = this;
        const data = this.data;
        let html = '';
        let separator = '';

        data.forEach((_release) => {
            const release = self.releaseCache.get(_release.release_id);
            const releaseValid = _release.valid;

            if (releaseValid.length && releaseValid.includes('base')) {
                html += ('<div class="ui-dialog__release-heading">' + release.get('title') + '</div>');
                releaseValid.forEach((_valid) => {
                    if (_valid === 'base') {
                        html += renderAlert('success', '', _T('success_valid_for_distribution'));
                    } else {
                        const channel = self.channelCache.get(_valid).attributes;
                        html += renderAlert('success', '', _T('this release is valid for these channels'));
                        html += `<ul class='ui-dialog__success success__list' id='valid_channels'>
                                    <li class='ui-dialog__success success__list-item'>
                                        <div class='ui-dialog__channels channels__logo'>
                                            <img src='${((channel.logo && channel.logo['40']) ? channel.logo['40'].href : self.settings.default_logo)}'/>
                                        </div>${channel.name}
                                    </li>
                                </ul>`;
                    }
                });
            }

            if (itemSize(_release.errors) > 0) {
                let alertMessage = _T('base_validation_errors');
                html += ('<div class="ui-dialog__release-heading">' + release.get('title') + '</div>');

                const baseErrors = _release.errors.filter(error => error.channel_id === "base" || error.channel_id === "empty");
                if (baseErrors.length > 0) {
                    let alertType = 'error';
                    if (this.in_form_validation) {
                        alertType = 'warn';
                        alertMessage = _T('base_channel_distribution_warn_message');
                    }
                    html += renderAlert(alertType, '', alertMessage);
                    html += this.renderErrors(self, baseErrors, 'base');
                    separator = '<div class="ui-dialog__alert.separator">&nbsp;</div>';
                }

                const otherErrors = _release.errors.filter(error => error.channel_id !== "base");
                if (otherErrors.length > 0) {
                    html += separator;
                    html += renderAlert('warn', '', _T('channel_validation_errors'))
                    html += this.renderErrors(self, otherErrors, '');
                }
            }
        })
        this.settings.container.html(html);
    },

    // Loop through errors in ReleaseErrorsDialog
    renderErrors: (self, errorsArray, channelName) => {
        let html = '';

        errorsArray.forEach((_per_channel) => {
            if (channelName !== 'base') {
                const channelName = self.channelCache.get(_per_channel.channel_id).attributes.name;
                html += `<div class="ui-dialog__errors errors__heading">${channelName}</div>`;
            }
            html += self._renderErrorBlock(_per_channel.release);
            html += self._renderErrorBlock(_per_channel.album);
            html += self._renderErrorBlock(_per_channel.ringtone);

            if (Array.isArray(_per_channel.tracks)) {
                const tracksPerChannel = _per_channel.tracks;
                tracksPerChannel.forEach((_track) => {
                    const track = self.trackCache.get(_track.track_id).attributes;
                    html += `<p class="ui-dialog__errors errors__title">
                            ${((_track.track_no) ? _track.track_no + '. ' : '') + (track.title ? track.full_title + ':' : _T('untitled track'))}
                        </p>
                        ${self._renderErrorBlock(_track.errors)}`
                })
            }
            if (Array.isArray(_per_channel.artists)) {
                const artistsPerChannel = _per_channel.artists;
                artistsPerChannel.forEach((_artist) => {
                    const artist = self.artistCache.get(_artist.artist_id).attributes;
                    html += `<p class="ui-dialog__errors errors__title">
                            ${(artist.name ? artist.name + ':' : _T('unnamed artist'))}
                        </p>
                        ${self._renderErrorBlock(_artist.errors)}`
                });
            }
        })
        return html;
    },

    _renderErrorBlock: (_errors) => {
        let html = '';
        const errors = _errors;
        if (isset(errors)) {
            html += '<ul class="ui-dialog__errors errors__list">';
            errors.forEach((_value) => {
                html += `<li class="ui-dialog__errors errors__list-item">${_T(_value)}</li>`;
            })
            html += '</ul>';
        }
        return html;
    },

    refresh: function () {
        if (this.settings.initial) {
            this.onData(this.settings.initial);
            this.settings.initial = null;
        } else {
            const self = this;
            $.ajax(this.settings.url, {async: false})
                .done(function (_data) {
                    self.onData(_data);
                });
        }
        if (this.settings.afterUpdate) {
            this.settings.afterUpdate(this);
        }
    },

    show: function () {
        const self = this;
        this.refresh();
        this.render();

        const buttons = [{
            text: _T('close'),
            class: 'ui-button--close',
            click: function () {
                self._closeDialog();
            }
        }];

        this.settings.container.dialog({
            buttons: buttons,
            close: function () {
                self._closeDialog();
            },
            closeText: '',
            dialogClass: setDialogClass('release_preview_errors'),
            draggable: false,
            hide: 'fade',
            minHeight: 386,
            maxHeight: 586,
            modal: true,
            position: {at: 'top+8%', my: 'top+8%'},
            resizable: false,
            title: this.title,
            show: 'fade',
            width: 550,
            zIndex: 100000
        });
    },

    close: function () {
        this._closeDialog();
    },

    _closeDialog: function () {
        enableUserActions();
        this.settings.container.dialog('close');
    },
};


/**
 **********************************************
 * TRACK ERRORS DIALOG
 **********************************************
 */
TrackErrorsDialog = function (_settings) {
    this.create(_settings || {});
};
TrackErrorsDialog.prototype = {
    create: function (_settings) {
        this.title = _settings.title ? _settings.title : _T('track preview validation errors');
        this.channelCache = _settings.channelCache;
        this.trackCache = _settings.trackCache;
        this.settings = _settings;
        this.valid = false;
        this.in_form_validation = _settings.in_form_validation ? true : false;
        var self = this;
        if (this.settings.button) {
            $(document).off('click', this.settings.button.selector); //Clear previous click events
            $(document).on('click', this.settings.button.selector, function (e) {
                self.show();
            });
        }
    },
    isValid: function () {
        return this.valid;
    },
    onData: function (_data) {
        this.valid = true;
        if (_data === true || itemSize(_data) === 0) {
            this.data = {};
            return;
        }

        if (!Array.isArray(_data)) {
            _data = [_data];
        }
        this.data = _data;

        var channels = [];
        let tracks = [];

        for (var i in _data) {
            var track = _data[i];
            tracks.push(track.track_id);
            this.valid = this.valid && (itemSize(track.errors) === 0);
            for (var j in track.errors) {
                channels.push(track.errors[j].channel_id);
            }
            channels = channels.concat(track.valid);
        }

        // TODO : this.channelCache candidate to be removed because no channels listing is shown
        this.channelCache.fetch({async: false, add: true, ids: without(channels, 'base')});
        this.trackCache.fetch({async: false, add: true, ids: tracks});

        if (this.valid) {
            this.settings.button.hide();
        } else {
            this.settings.button.show();
        }
    },
    render: function () {
        this.settings.container.html('');
        var self = this;
        const data = this.data;
        var html = '';
        let separator = '';

        data.forEach((_track) => {
            const track = self.trackCache.get(_track.track_id).attributes;
            const trackErrors = _track.errors;

            if (itemSize(trackErrors) > 0) {
                let alertMessage = _T('base_validation_errors');
                html += ('<div class="ui-dialog__release-heading">' + track.title + '</div>');

                const baseErrors = trackErrors.filter(error => error.channel_id === "base" || error.channel_id === "empty");
                if (baseErrors.length > 0) {
                    let alertType = 'error';
                    if (this.in_form_validation) {
                        alertType = 'warn';
                        alertMessage = _T('base_channel_distribution_warn_message');
                    }
                    html += renderAlert(alertType, '', alertMessage);
                    html += this.renderErrors(self, baseErrors, 'base');
                    separator = '<div class="ui-dialog__alert.separator">&nbsp;</div>';
                }

                const otherErrors = trackErrors.filter(error => error.channel_id !== "base");
                if (otherErrors.length > 0) {
                    html += separator;
                    html += renderAlert('warn', '', _T('channel_validation_errors'))
                    html += this.renderErrors(self, otherErrors, '');
                }
            }
        });

        this.settings.container.html(html);
    },

    // Loop through errors in TrackErrorsDialog
    renderErrors: (self, errorsArray, channelName) => {
        let html = '';

        errorsArray.forEach((_per_channel) => {
            if (channelName !== 'base') {
                const channelName = self.channelCache.get(_per_channel.channel_id).attributes.name;
                html += `<div class="ui-dialog__errors errors__heading">${channelName}</div>`;
            }
            html += self._renderErrorBlock(_per_channel.release);
            html += self._renderErrorBlock(_per_channel.album);
            html += self._renderErrorBlock(_per_channel.ringtone);

            if (Array.isArray(_per_channel.tracks)) {
                const tracksPerChannel = _per_channel.tracks;
                tracksPerChannel.forEach((_track) => {
                    html += `${self._renderErrorBlock(_track.errors)}`
                })
            }
        })
        return html;
    },

    _renderErrorBlock: (_errors) => {
        let html = '';
        const errors = _errors;
        if (isset(errors)) {
            html += '<ul class="ui-dialog__errors errors__list">';
            errors.forEach((_value) => {
                html += `<li class="ui-dialog__errors errors__list-item">${_T(_value)}</li>`;
            })
            html += '</ul>';
        }
        return html;
    },

    refresh: function () {
        if (this.settings.initial) {
            this.onData(this.settings.initial);
            this.settings.initial = null;
        } else {
            var self = this;
            $.ajax(this.settings.url, {async: false})
                .done(function (_data) {
                    self.onData(_data);
                });
        }
        if (this.settings.afterUpdate) {
            this.settings.afterUpdate(this);
        }
    },

    show: function () {
        const self = this;
        this.refresh();
        this.render();

        const buttons = [{
            text: _T('close'),
            class: 'ui-button--close',
            click: function () {
                self._closeDialog();
            }
        }];

        this.settings.container.dialog({
            buttons: buttons,
            close: function () {
                self._closeDialog();
            },
            closeText: '',
            dialogClass: setDialogClass('release_preview_errors'),
            draggable: false,
            hide: 'fade',
            minHeight: 386,
            maxHeight: 586,
            modal: true,
            position: {at: 'center', my: 'center'},
            resizable: false,
            title: this.title,
            show: 'fade',
            width: 550,
            zIndex: 100000
        });
    },

    _closeDialog: function () {
        this.settings.container.dialog('close');
    },
};

/**
 **********************************************
 * OPEN CREATE DIALOG
 **********************************************
 */
OpenCreateDialog = function (_settings) {
    this.create(_settings || {});
};
OpenCreateDialog.prototype = {
    create: function (_settings) {
        this.settings = _settings;

        this.open_button = $('#' + this.settings.name);
        var self = this;

        if (!this.settings.buttons) {
            this.settings.buttons = {};
        }

        if (!_settings.buttons['create']) {
            this.settings.buttons['create'] = function () {
                $('#' + self.settings.name + '_form').submit();
            };
        }
        for (var i in this.settings.buttons) {
            var action = this.settings.buttons[i];
            delete (this.settings.buttons[i]);
            this.settings.buttons[_T(this.settings.name + '___' + i)] = action;
        }

        this.open_button.click(function () {
            var title = self.settings.name + '_modal';
            var div = $('<div id="' + title + '" title="' + _T(title) + '"></div>');

            self.compose(div);

            var form = div.find('#' + self.settings.name + '_form');
            var ids = [];
            for (var i in self.settings.fields) {
                var id = self.settings.name + '_' + i;
                ids.push(id);
            }
            postFormData({
                form: form,
                url: form.attr('action'),
                ids: ids,
                beforeSubmit: function () {
                    $('#create_error').remove();
                },
                onComplete: function (_xhr, _textStatus) {
                    return false;
                },
                onSuccess: function (_data, _textStatus, _xhr) {
                    div.dialog('close');
                    if (self.settings.onSuccess) {
                        self.settings.onSuccess(_data, _textStatus, _xhr);
                    } else {
                        doLoad(_xhr.getResponseHeader('Location'));
                    }
                    return false;
                },
                onError: function (_xhr, _error) {
                    var text;
                    var response;
                    if (_.isEmpty(_xhr.responseText)) {
                        text = _T('Unknown error');
                    } else {
                        response = new ApiResponse(JSON.parse(_xhr.responseText), {element: 'li'});
                        text = '<ul>' + response.getHumanMsgs() + '</ul>';
                    }
                    var error_label = $('<label></label>').attr('id', 'create_error').addClass('error').html(text);
                    $('#' + ids[0]).after(error_label);
                    return false;
                }
            });
            div.removeClass('hidden');
            div.dialog({
                modal: true,
                width: 800,
                position: {at: 'top+96'},
                buttons: self.settings.buttons,
                close: function () {
                    self.div.html('');
                    enableUserActions();
                },
                zIndex: 100000
            });

            return false;
        });
    },
    compose: function (_container) {
        this.div = _container;
        this.form = $('<form id="' + this.settings.name + '_form" method="post" action="' + this.settings.url + '"></form>');
        for (var i in this.settings.fields) {
            if (this.settings.fields[i] == 'hidden') {
                this.form.append($('<input type="hidden" name="' + i + '" id="' + this.settings.name + '_' + i + '"/>'));
            }
        }

        var table = $('<table class="form_container"></table>');
        for (var j in this.settings.fields) {
            if (this.settings.fields[j] != 'hidden') {
                var tr = $("\
<tr>\
  <td class='f'>" + _T(this.settings.name + '_label_' + j) + "</td>\
  <td class='big_data'>\
    <input class='" + (this.settings.fields[j] == 'text' ? 'full ' : '') + "text' type='" + this.settings.fields[j] + "' name='" + j + "' id='" + this.settings.name + '_' + j + "'/>\
  </td>\
</tr>");
                table.append(tr);
            }
        }

        this.form.append(table);
        this.div.append(this.form);

        if (this.settings.values) {
            for (var k in this.settings.values) {
                var field = this.form.find('#' + this.settings.name + '_' + k);
                (field.attr('type') == 'checkbox')
                    ? field.prop('checked', this.settings.values[k])
                    : field.val(this.settings.values[k]);
            }
        }
    }
};

/**
 **********************************************
 * CHANNELS SELECTOR
 **********************************************
 */
ChannelsSelector = function (_settings) {
    this.create(_settings || {});
};
ChannelsSelector.prototype = {
    create: function (_settings) {
        this.settings = _settings;
        this.channelCache = _settings.channelCache;
        this.releaseCache = _settings.releaseCache;
        this.trackCache = _settings.trackCache;
        this.artistCache = _settings.artistCache;
        this.dialog = null;
        this.cart = null;
        this.forAdmin = typeof _settings.forAdmin === 'undefined' ? false : _settings.forAdmin;
        this._reset();
    },

    _reset: function () {
        this.releaseIds = [];
    },

    setCart: function (_cart) {
        this.cart = _cart;
    },

    _onData: function (_data) {
        let trackIds = [];
        let artistIds = [];
        let channelIds = [];
        let channelsErrors = {};
        const self = this;

        _data.forEach((_byRelease) => {
            channelIds = channelIds.concat(_byRelease.valid);
            self.releaseIds.push(_byRelease.release_id);
            const errorsByRelease = _byRelease.errors;

            errorsByRelease.forEach((_errors) => {
                if (_errors.tracks) {
                    _errors.tracks.map((_byTrack) => trackIds.push(_byTrack.track_id))
                }
                if (_errors.artists) {
                    _errors.artists.map((_byArtist) => artistIds.push(_byArtist.artist_id))
                }
                if (!channelsErrors[_errors.channel_id]) {
                    channelsErrors[_errors.channel_id] = {};
                }
                channelsErrors[_errors.channel_id][_byRelease.release_id] = _errors;
            });
        });

        this.releaseIds = [...new Set(self.releaseIds)];
        channelIds = [...new Set(without(union(channelIds, Object.keys(channelsErrors)), 'base', 'empty'))];
        channelIds = channelIds.map(i => Number(i));

        if (!channelIds.length && channelIds.filter(id => !Object.keys(channelsErrors).includes(id))) {
            alert(_T('no compatible channels found'));
            end_spin();
            enableUserActions();
            return;
        }
        if (itemSize(channelIds) === 1) {
            if (this.forAdmin) {
                this._sendToWaiting(channelIds);
            } else {
                this._postSelected(channelIds);
            }
            return;
        }

        $.when(this.channelCache.fetch({add: true, ids: channelIds}),
            this.trackCache.fetch({add: true, ids: trackIds}),
            this.artistCache.fetch({add: true, ids: artistIds}),
            this.releaseCache.fetch({add: true, ids: this.releaseIds}))
            .always(function () {
                self._render(channelIds, channelsErrors);
            });
    },

    _render: function (_channelIds, _errors) {
        const self = this;
        const channelsIds = _channelIds;
        const channels = _.sortBy(channelsIds.map(_id => self.channelCache.get(_id)), (channel) => channel.get('code'));

        let form = `<form id='channels-selector' class='center' action='#'>
            <div class='ui-dialog__channels channels__container'>
                <div class='ui-dialog__channels channels__all left'><div class='ui-dialog__channels channels__checkbox'>
                    <input id='channels-selector-all' type='checkbox'/>
                </div>
                <label for='channels-selector-all' class='ui-dialog__channels channels__all-label'> ${_T('All')}</label>
            </div>`

        channels.forEach((_channel) => {
            const id = 'channel_' + _channel.get('id');
            const channelErrors = _errors[_channel.get('id')];
            let errors = [];

            form += !_.isEmpty(channelErrors) ?
                `<div class='ui-dialog__channels channels__item'>
                    <div class='ui-dialog__channels channels__warn ${_.any(channelErrors) ? 'jtooltip' : ''}' id='selector_channel_jtooltip_${id}'>
                        <span class='channel_selector_incompatible'></span>
                    </div>
                    <div id='selector_channel_logo_${id}' class='ui-dialog__channels channels__logo'></div>
                    <label class='ui-dialog__channels channels__label' for='${id}'>${_channel.get('name')}</label>`
                : `<div class='ui-dialog__channels channels__item'>
                        <div class='ui-dialog__channels channels__checkbox'>
                            <input id='${id}' type='checkbox' channel_id='${_channel.get('id')}' value='${_channel.get('id')}' name='channel_code'/>
                        </div>
                        <div id='selector_channel_logo_${id}' class='ui-dialog__channels channels__logo'></div>
                        <label class='ui-dialog__channels channels__label' for='${id}'>${_channel.get('name')}</label>`;

            _.each(channelErrors, function (_error, _releaseId) {
                const releaseTitle = _releaseId ? self.releaseCache.get(_releaseId).get('title') : null;
                const listErrors = (errors) => {
                    return `<ul>${errors.map(error => (`<li class="ui-widget-tooltip__list-item">${error}</li>`)).join('')}</ul>`
                }

                if (_error.release) {
                    errors.push(`<strong class="ui-widget-tooltip__list-item-title release__title">${(releaseTitle ? releaseTitle : _T('untitled release'))}</strong>${listErrors(_error.release)}`);
                }
                if (_error.album) {
                    errors.push(`<strong class="ui-widget-tooltip__list-item-title release__title">${(releaseTitle ? releaseTitle : _T('untitled release'))}</strong>${listErrors(_error.album)}`);
                }
                if (_error.artists) {
                    _error.artists.forEach((_byArtist) => {
                        const name = _byArtist.artist_id ? self.artistCache.get(_byArtist.artist_id).get('name') : null;
                        errors.push(`<strong class="ui-widget-tooltip__list-item-title">${(name ? name : _T('unnamed artist'))}</strong>${listErrors(_byArtist.errors)}`);
                    });
                }
                if (_error.tracks) {
                    _error.tracks.forEach((_byTrack) => {
                        const trackTitle = _byTrack.track_id ? self.trackCache.get(_byTrack.track_id).get('title') : null;
                        errors.push(`<strong class="ui-widget-tooltip__list-item-title">${_byTrack.track_no} ${(trackTitle ? trackTitle : _T('untitled track'))}</strong>${listErrors(_byTrack.errors)}`);
                    });
                }
            });

            if (errors.length > 0) {
                form += `<div id='selector_channel_jtooltip_${id}_tooltip' class='none'><ul>
                    ${errors.map((val) => {
                    return `<li class="ui-widget-tooltip__error-container">${val}</li>`
                }).join('')}</ul></div>`;
            }
            form += "</div>";
        });

        form += "</div></form>";
        form = $(form);

        form.find('#channels-selector-all').click(function () {
            const state = $('#channels-selector-all').prop('checked');
            $('#channels-selector input[id != channels-selector-all]').prop('checked', state);
        });

        form.submit(function () {
            return false;
        });

        this.dialog = $(`<div title="${_T('select channels to publish on')}"></div>`).append(form);

        const buttons = [{
            text: _T('Cancel'),
            class: 'ui-button--close warning',
            click: function () {
                self._closeDialog();
            }
        }];

        if (this.forAdmin) {
            buttons.push({
                text: _T('send_to_waiting_for_distribution'),
                class: 'ui-button--distribute',
                click: function () {
                    self._onSubmit(form);
                }
            });
            buttons.push({
                text: _T('send_to_waiting_for_takedown'),
                class: 'ui-button--takedown',
                click: function () {
                    self._onSubmit(form, 't');
                }
            });
        } else {
            buttons.push({
                text: _T('select channels'),
                class: 'ui-button--distribute',
                click: function () {
                    self._onSubmit(form);
                }
            });
        }

        this.dialog.dialog({
            buttons: buttons,
            close: function () {
                self._closeDialog();
            },
            closeText: '',
            dialogClass: setDialogClass('channels_selector'),
            draggable: false,
            height: 'auto',
            hide: 'fade',
            minHeight: 586,
            modal: true,
            open: postRender,
            position: {at: 'center', my: 'center'},
            resizable: false,
            show: 'fade',
            width: 960,
            zIndex: 100000
        });

        channels.forEach((_channel) => {
            $(`#selector_channel_logo_${'channel_'}${_channel.get('id')}`).append((new ModelHelper(_channel.attributes, 'channels')).getImage('logo', '40', 'channel'));
        });

        form.find('#channels-selector-all').click();

        end_spin();
    },

    _onSubmit: function (form, action) {
        start_spin();
        action = typeof action !== 'undefined' ? action : null;
        const checked = $(form).find("input:checked");
        const selected = _.map($('input[channel_id]:checked'), function (_ck) {
            return $(_ck).attr('channel_id');
        });

        if (_.any(selected)) {
            if (this.forAdmin) {
                this._sendToWaiting(selected, action);
            } else {
                this._postSelected(selected);
            }
            $('#releases_pager input[type=checkbox]').prop('checked', false);
        }
        this._closeDialog();
    },

    _postSelected: function (_selected) {
        const self = this;
        const selected = _selected;
        const releaseIds = this.releaseIds;

        $.post(this.settings.url, JSON.stringify([{'releases': releaseIds, 'channels': selected}]))
            .fail(function (_xhr) {
                alert(_.reduce(new ApiResponse(JSON.parse(_xhr.responseText)).getMsgs(),
                    function (_memo, _item) {
                        return _memo + _item + "\n";
                    }, ''));
                end_spin();
            })
            .done(function (data) {
                end_spin();
                var onDone = function () {
                    self.cart ? self.cart.refresh(true) : doLoad('/orders/current');
                    if (dialog) {
                        dialog.close();
                    }
                };

                unsaved = [];

                if (_.isEmpty(data)) {
                    _.each(releaseIds, function (_release_id) {
                        unsaved[_release_id] = selected;
                    });
                } else {
                    _.each(data, function (_data, _release_id) {
                        channel_ids = Object.keys(_data);
                        diff = _.difference(selected, channel_ids);
                        if (!_.isEmpty(diff)) {
                            unsaved[_release_id] = diff;
                        }
                    });
                }

                if (unsaved.length) {
                    body = renderAlert('warn', '', _T('Those releases already being processed for the following channels') + ':');

                    Object.keys(unsaved).forEach(_release_id => {
                        body += `<p class="ui-dialog__errors errors__title">${self.releaseCache.get(_release_id).get('title')}</p>`;
                        body += '<ul class="ui-dialog__errors errors__list">';
                        unsaved[_release_id].forEach(_channel_id => {
                            body += `<li class="ui-dialog__errors errors__list-item">${self.channelCache.get(_channel_id).get('name')}</li>`;
                        });
                        body += '</ul>';
                    });

                    var dialog = new GenericDialog({
                        body: body,
                        buttons: [{
                            text: _T('Ok'),
                            class: 'ui-button--distribute',
                            click: onDone
                        }],
                        closeText: '',
                        dialogClass: setDialogClass('channels_export_result'),
                        position: {at: 'center', my: 'center'},
                        title: _T('Warning'),
                        show: 'fade',
                        width: 550,
                        zIndex: 100000
                    });

                    dialog.show();
                    return false;
                }
                onDone();
            });
    },

    _sendToWaiting: function (_selected, action) {
        $.post('/api/1.0/exports', JSON.stringify([{
            'releases': this.releaseIds,
            'channels': _selected,
            'action': action
        }]))
            .done(function (data) {
                let title, message;
                title = _T('Exports');
                message = '';

                data.forEach(result => {
                    message += `<div class="ui-dialog__release-heading">${result.release}</div>`;
                    if (result.channels.success.length > 0) {
                        message += renderAlert('success', '', _T('This export has been created.'));
                        message += '<ul class="ui-dialog__success success__list">';
                        result.channels.success.forEach(success => {
                            message += `<li class="ui-dialog__success success__list-item">${success}</li>`;
                        });
                        message += '</ul>';
                    }
                    if (result.channels.error.length > 0) {
                        message += renderAlert('error', '', _T('Export could not be created'));
                        message += '<ul class="ui-dialog__errors errors__list">';
                        result.channels.error.forEach(error => {
                            message += `<li class="ui-dialog__errors errors__list-item">${error}</li>`
                        });
                        message += '</ul>';
                    }
                });

                const dialog = new GenericDialog({
                    body: message,
                    buttons: [{
                        text: _T('close'),
                        class: 'ui-button--close warning',
                        click: function () {
                            dialog.close();
                        }
                    }],
                    closeText: '',
                    dialogClass: setDialogClass('channels_export_result'),
                    position: {at: 'center', my: 'center'},
                    title: title,
                    width: 550,
                    zIndex: 100000
                });

                end_spin();
                dialog.show();
                return false;
            })
            .fail(function (e) {
                let errorMessage;
                switch (e.status) {
                    case 400:
                        errorMessage = e.responseJSON['400'][0].CANNOT_ADD_RELEASE_WITH_VALIDATION_ERRORS;
                        break;
                }
                if (errorMessage) {
                    const export_warning_dialog = new GenericDialog({
                        body: renderAlert('error', '', errorMessage),
                        buttons: [{
                            text: _T('close'),
                            class: 'ui-button--close warning',
                            click: function () {
                                export_warning_dialog.close();
                            }
                        }],
                        closeText: '',
                        dialogClass: setDialogClass('channels_export_result'),
                        position: {at: 'center', my: 'center'},
                        title: _T('Error'),
                        width: 550,
                        zIndex: 100000
                    });
                    export_warning_dialog.show();
                }
                end_spin();
                return false;
            });
    },

    _closeDialog: function () {
        $('#channels-selector').remove();
        $(this.dialog).dialog('close');
        $(this.dialog).dialog('destroy');
        this.dialog = null;
        enableUserActions();
        this._reset();
    },

    show: function (_releasesIds) {
        if (_releasesIds.length === 0) {
            alert(_T('no releases selected'));
            return;
        }

        if (this.settings.initial) {
            this._onData(this.settings.initial);
            this.settings.initial = null;
        } else {
            const self = this;
            start_spin();
            $.ajax('/api/1.0/channels/is_release_compatible/' + _releasesIds.join(','))
                .fail(function (jqXHR, text) {
                    alert(text);
                })
                .done(function (_data) {
                    self._onData(_data);
                });
        }
    }
};

/**
 **********************************************
 * ZENDESK TICKET
 **********************************************
 */
ZendeskTicket = function (_settings) {
    this.create(_settings || {});
};

ZendeskTicket.prototype = {
    create: function (_settings) {
        this.settings = _settings;
        this._dialog = null;

        if (this.settings.onFinish) {
            this._onFinish = this.settings.onFinish;
        }
    },

    show: function () {
        const self = this;
        this.selectedValues = {};
        this._dialog = this._showForm();
        const form = this._dialog

        const buttons = [
            {
                text: _T('Cancel'),
                class: 'ui-button--close warning',
                click: function () {
                    self._closeDialog();
                }
            },
            {
                text: _T('save'),
                class: 'ui-button--distribute',
                click: function () {
                    self._onSubmit(form);
                }
            }
        ];

        this._dialog.dialog({
            buttons: buttons,
            close: function () {
                self._closeDialog();
            },
            closeText: '',
            dialogClass: setDialogClass('zendesk_ticket_dialog'),
            draggable: false,
            hide: 'fade',
            minHeight: 228,
            maxHeight: 758,
            modal: true,
            position: {at: 'top+8%', my: 'top+8%'},
            resizable: false,
            title: _T('zendesk_ticket_dialog_title'),
            show: 'fade',
            width: 550,
            zIndex: 100000
        });
    },

    _closeDialog: function () {
        $(this._dialog).dialog('close');
        $(this._dialog).dialog('destroy');
        enableUserActions();
        this._dialog = null;
    },

    _showForm: function () {
        let form = `<form action="#">
                    <div class="ui-dialog__zendesk-form-fields">
                        <div class="zendesk-form-field">
                            <label
                                for="zendesk_ticket_number"
                                class="zendesk-form-label"
                            >
                                ${_T('Ticket number')}
                            </label>
                            <input
                                type='text'
                                id='zendesk_ticket_number'
                                class="zendesk-form-input"
                                placeholder=""
                                tabindex="-1"
                            />
                        </div>
                    </div>
            </form>`;

        return $(form);
    },

    _onSubmit: function (form) {
        const self = this;
        const ticket_number = $(form).find('#zendesk_ticket_number').val();

        const isNumber = /^\d+$/.test(ticket_number);

        if (!ticket_number) {
            alert(_T('zendesk_ticket_id_required'));
            return;
        }

        if (!isNumber) {
            alert(_T('only_numbers'));
            return;
        }

        const payload = {
            ticket_number: ticket_number
        };

        $.post('/api/1.0/releases/' + this.settings.release_id + '/zendesk_qc_ticket', JSON.stringify(payload))
            .fail(function () {
                self._onError();
            })
            .always(function () {
                self._onFinish();
                self._closeDialog();
            });
    },

    _onError: function () {
        alert(_T('an error happened while inserting ticket id'));
        enableUserActions();
    },
    _onFinish: function () {
    }
};


/**
 **********************************************
 * CONFIRM SALES DOWNLOAD
 **********************************************
 */
ConfirmSalesDownloadDialog = function (_settings) {
    this.create(_settings || {});
};
ConfirmSalesDownloadDialog.prototype = {
    create: function (_settings) {
        this.settings = _settings;
        this._dialog = null;
    },
    show: function () {
        var self = this;
        this._dialog = $('<div title="' + _T('Confirm sales download') + '"></div>').append(form = this._showForm());
        this._dialog.dialog({
            modal: true,
            position: {at: 'top+96'},
            buttons: [{
                text: _T('Cancel'),
                class: 'warning',
                click: function () {
                    self._closeDialog();
                }
            },
                {
                    text: _T('Download'),
                    click: function () {
                        self._onSubmit(form);
                    }
                }],
            close: function () {
                self._closeDialog();
            },
            width: 400,
            zIndex: 100000
        });

        new BtnFMDatePicker({
            id: 'download_dates_filter_start',
            field: 'created_at',
            calendar_button: '/images/default/calendar.gif'
        });
        new BtnFMDatePicker({
            id: 'download_dates_filter_end',
            field: 'created_at',
            calendar_button: '/images/default/calendar.gif'
        });

        $('#download_dates_filter_start').blur(); // Fix datepicker not shown on first click bug
    },
    _closeDialog: function () {
        $(this._dialog).dialog('close');
        $(this._dialog).dialog('destroy');
        this._dialog = null;
    },
    _showForm: function () {

        var self = this;
        var form = "\
        <form action='#'>\
            <table width='100%'>\
                <tbody>\
                    <tr>\
                        <td style='padding-top: 10px;'>\
                            <input type='text' id='download_dates_filter_start' style='xwidth: 75%;' readonly='readonly' placeholder='" + _T('From') + "' class='std-input std-textfield' value='" + moment().format('YYYY-MM-01') + "'/>\
                            <input type='text' id='download_dates_filter_end' style='xwidth: 75%;' readonly='readonly' placeholder='" + _T('To') + "' class='std-input std-textfield' value='" + moment().format('YYYY-MM-DD') + "'/>\
                        </td>\
                    </tr>\
                </tbody>\
            </table>\
        </form>";

        form = $(form);

        return form;
    },
    _onSubmit: function (form) {

        var self = this;
        var dates = $('#download_dates_filter_start').val().trim() + '/' + $('#download_dates_filter_end').val().trim();

        window.location.href = '/api/1.0/sales_confirmations/by_tenant/filter/created_at/' + encodeURIComponent(dates) + '.csv';
        self._closeDialog();
    }
};


/**
 **********************************************
 * SALES REPORTS BY PERIOD
 **********************************************
 */
DownloadSalesReportsByPeriod = function (_settings) {
    this.create(_settings || {});
};
DownloadSalesReportsByPeriod.prototype = {
    create: function (_settings) {
        this.settings = _settings;
        this._dialog = null;
    },
    show: function () {
        var self = this;
        this._dialog = $('<div title="' + _T('download_sales_report_by_period') + '"></div>').append(form = this._showForm());
        this._dialog.dialog({
            modal: true,
            position: {at: 'top+96'},
            buttons: [{
                text: _T('Cancel'),
                class: 'warning',
                click: function () {
                    self._closeDialog();
                }
            },
                {
                    text: _T('Download'),
                    click: function () {
                        self._onSubmit(form);
                    }
                }],
            close: function () {
                self._closeDialog();
            },
            width: 350,
            zIndex: 100000
        });

        new BtnFMMonthPicker({id: 'download_dates_sales_report_start'});
        new BtnFMMonthPicker({id: 'download_dates_sales_report_end'});
    },
    _closeDialog: function () {
        $(this._dialog).dialog('close');
        $(this._dialog).dialog('destroy');
        this._dialog = null;

        if (this.settings.pager) {
            this.settings.pager.page();
        }
    },
    _showForm: function () {
        var self = this;
        var selectorFilterDates = "";

        if (this.settings.filter_by_date_selector !== undefined) {
            selectorFilterDates = "<tr>\
                <td style='padding-top: 10px;'>\
                    <div style='display: inline-block;width: 18%;'><b>" + _T('filter') + "</b></div>\
                    <div style='display: inline-block;width: 80%;'><select id='download_dates_sales_filter' style='width: 100%'><option value='sales_dates'>" + _T('sales_modal_filter_sales') + "</option><option value='confirm_dates'>" + _T('sales_modal_filter_confirmation') + "</option></select></div>\
                </td>\
            </tr>"
        }

        var form = "\
        <form action='#'>\
        <p id='download_sales_report-error-message' style='color: red;margin:0;display: none;'>" + _T('download_sales_report_error_message') + "</p>\
            <table width='100%'>\
                <tbody>\
                    <tr>\
                        <td style='padding-top: 10px;'>\
                            <div style='display: inline-block;width: 18%;'><b>" + _T('from') + "</b></div>\
                            <div style='display: inline-block;width: 80%;'><input type='text' id='download_dates_sales_report_start' class='std-input std-textfield' style='width: 100%'/></div>\
                        </td>\
                    </tr>\
                    <tr>\
                        <td style='padding-top: 10px;'>\
                            <div style='display: inline-block;width: 18%;'><b>" + _T('to') + "</b></div>\
                            <div style='display: inline-block;width: 80%;'><input type='text' id='download_dates_sales_report_end' class='std-input std-textfield' style='width: 100%'/></div>\
                        </td>\
                    </tr>" + selectorFilterDates + "\
                </tbody>\
            </table>\
        </form>";

        form = $(form);

        return form;
    },
    _onSubmit: function (form) {
        var dateFormatter = function (date, start) {
            start = start ? true : false;

            var m = date ? moment(date, 'MM/YYYY') : moment();

            if (!start) {
                m = m.endOf("month").add(1, "day");
            }

            return m.format(DATE_FORMAT_ISO_DATE);
        };

        var salesReportStart = $('#download_dates_sales_report_start').val().trim();
        var salesReportEnd = $('#download_dates_sales_report_end').val().trim();
        var filterByType = null;

        if (this.settings.filter_by_date_selector !== undefined) {
            filterByType = $("#download_dates_sales_filter").val();
        }

        var filter = {};

        if (salesReportStart !== '' && salesReportEnd !== '') {
            let reportYear = parseInt(salesReportStart.split("/")[1], 10);
            let reportMonth = parseInt(salesReportStart.split("/")[0], 10);
            if (reportYear > 2022) {
                if (2023 === reportYear && 1 === reportMonth) {
                    $("#download_sales_report-error-message").show();
                    setTimeout(function () {
                        $("#download_sales_report-error-message").hide();
                    }, 5000);
                } else {
                    filter['start_date'] = dateFormatter(salesReportStart, true);
                    filter['end_date'] = dateFormatter(salesReportEnd);

                    if (null !== filterByType) {
                        filter['filter_date_type'] = filterByType;
                    }

                    var qs = Object.keys(filter).map(k => `filter[${k}]=${filter[k]}`).join('&');
                    window.location.href = '/api/1.0/sales/by_' + this.settings.action + '_report/.csv?' + qs;
                    this._closeDialog();
                }
            } else {
                $("#download_sales_report-error-message").show();
                setTimeout(function () {
                    $("#download_sales_report-error-message").hide();
                }, 5000);
            }
        }
    }
};

/**
 **********************************************
 * GENERIC DIALOG
 **********************************************
 */
GenericDialog = function (_settings) {
    this.create(_settings || {});
};

GenericDialog.prototype = {
    create: function (_settings) {
        this.settings = _.extend({width: 480}, _settings);
        this._dialog = null;
    },

    show: function () {
        const self = this;
        this._dialog = $(`<div title="${this.settings.title}"></div>`).append(this._showBody());
        this._dialog.data(self.getData());

        this._dialog.dialog({
            buttons: this.settings.buttons ? this.settings.buttons : [],
            close: function () {
                self._closeDialog();
            },
            closeText: self.settings.closeText ? self.settings.closeText : '',
            dialogClass: self.settings.dialogClass ? self.settings.dialogClass : '',
            draggable: false,
            hide: 'fade',
            minHeight: 286,
            maxHeight: 586,
            modal: true,
            position: self.settings.position ? self.settings.position : {at: 'top+96'},
            resizable: false,
            show: 'fade',
            width: self.settings.width,
            zIndex: 100000
        });
    },

    close: function () {
        this._closeDialog();
    },

    _showBody: function () {
        const body = _.isFunction(this.settings.body) ? this.settings.body(this.getData()) : this.settings.body;

        const form = "\
            <form action='#'>\
                <table width='100%'>\
                    <tbody>\
                        <tr>\
                            <td style='padding-top: 10px;'>" + body + "\
                            </td>\
                        </tr>\
                    </tbody>\
                </table>\
            </form>";

        return $(form);
    },

    setData: function (_data) {
        this.data = _data;
    },

    getData: function () {
        return this.data;
    },

    _closeDialog: function () {
        $(this._dialog).dialog('close');
        $(this._dialog).dialog('destroy');
        this._dialog = null;
    }
};

/**
 **********************************************
 * TOS CONFIRMATIONS
 **********************************************
 */
TOSConfirmationsDialog = function (_settings) {
    this.create(_settings || {});
};
TOSConfirmationsDialog.prototype = {
    create: function (_settings) {
        this.settings = _settings;
        this._channels = [];
        this._dialog = null;
    },

    show: function () {
        const self = this;
        this._dialog = this._showForm();

        const buttons = [
            {
                text: _T('Cancel'),
                class: 'ui-button--close warning',
                click: function () {
                    self._closeDialog();
                }
            },
            {
                text: _T('delivery'),
                class: 'ui-button--distribute',
                click: function () {
                    self._onSubmit(this._dialog);
                }
            }
        ];

        this._dialog.dialog({
            buttons: buttons,
            close: function () {
                self._closeDialog();
            },
            closeText: '',
            dialogClass: setDialogClass('tos_confirmations'),
            draggable: false,
            height: 'auto',
            hide: 'fade',
            minHeight: 386,
            maxHeight: 586,
            modal: true,
            position: {at: 'top+8%', my: 'top+8%'},
            resizable: false,
            title: _T('Please confirm'),
            show: 'fade',
            width: 550,
            zIndex: 100000
        });
    },

    setChannels: function (_channels) {
        this._channels = _channels;
    },

    _closeDialog: function () {
        $(this._dialog).dialog('close');
        $(this._dialog).dialog('destroy');
        this._dialog = null;
    },

    _showForm: function () {
        var self = this;
        var form = `<div id='confirmations'>
                ${renderAlert('warn', 'alert-medium', _T('Important notice: Once distributed you can only change information associated with the release via update orders'))}
                <div class="tos_confirmations__input-field">
                    <input
                        id='information_correct'
                        class="tos_confirmations__input-checkbox"
                        name='information_correct'
                        type='checkbox'
                    />
                    <label
                        for="information_correct"
                        class="tos_confirmations__input-label"
                    >
                        ${_T('Ok, I confirm all information of the releases included in this order is correct')}
                    </label>
                </div>`

        _.each(this._channels, function (_channel_id) {
            _channel = self.settings.channelCache.get(_channel_id).attributes;
            if (_channel.terms_of_use) {
                form += `<div class="tos_confirmations__input-field">
                    <input
                        id="accept_tos[${_channel.code}]"
                        class="tos_confirmations__input-checkbox"
                        name="accept_tos[${_channel.code}]"
                        type="checkbox"
                    />
                    <label
                        for="accept_tos[${_channel.code}]"
                        class="tos_confirmations__input-label"
                    >
                        <span class="tos_confirmations__input-label--bold">
                            ${_T('I accept %s terms of use', _channel.name)}:
                        </span>
                        ${_T(_channel.code + ' terms of use')}
                    </label>
                </div>`
            }
        });

        form += "</div>";

        form = $(form);
        return form;
    },

    _onSubmit: function (form) {
        const checkboxes = $('#confirmations input')
        const notChecked = $('#confirmations input:not(:checked)')

        Array.from(checkboxes).forEach(input => {
            input = input
            if (input.checked === true) {
                input.classList.remove('input-field--error')
                input.parentElement.classList.remove('input-field--error')
            } else {
                input.classList.add('input-field--error')
                input.parentElement.classList.add('input-field--error')
            }
        })

        if (notChecked.length > 0) {
            if ($('#unconfirmed').length === 0) {
                $('#confirmations').prepend(`<div id="unconfirmed" class="ui-dialog__tos_confirmations alert--error">${renderAlert('error', '', _T('accept_all_terms'))}</div>`)
            }
            return false;
        }

        this.onUserAcceptTOS();
        this._closeDialog();
    },

    onUserAcceptTOS: function () {
    }
};


/**
 **********************************************
 * AUDIO ANALYSIS DETAILS DIALOG
 **********************************************
 */
AudioAnalysisDetailsDialog = function (_settings) {
    this.create(_settings || {});
};
AudioAnalysisDetailsDialog.prototype = {
    create: function (_settings) {
        this.title = _settings.title ? _settings.title : _T('audio_analysis_details');
        this.settings = _settings;
        this.data = _settings.initial;
        this.track_title = _settings.track_title;
    },

    isValid: function () {
        return this.valid;
    },

    onData: function (_data) {
        this.valid = true;
        if (_data === true || itemSize(_data) === 0) {
            this.data = {};
            return;
        }
        this.data = _data;
    },
    fragmentDetails: function (fragment) {

        var musicBlocksList = [];

        var fragmentBlock = $('<div />');

        fragment.response.metadata.music.forEach((music, index) => {
            let musicBlockItem = window.$('<li style="margin-bottom: 10px">');
            musicBlockItem.append(window.$('<h3>Result ' + (index + 1) + '</h3>'));
            musicBlockItem.append(window.$('<div>Artist: ' + music.artists[0].name + '</div>'));
            musicBlockItem.append(window.$('<div>Album title: ' + music.album.name + '</div>'));
            musicBlockItem.append(window.$('<div>Track: ' + music.title + '</div>'));
            musicBlockItem.append(window.$('<div>Label: ' + music.label + '</div>'));
            musicBlockItem.append(window.$('<div>Score: ' + music.score + '%</div>'));
            musicBlockItem.append(window.$('<div>Score: ' + music + '%</div>'));
            musicBlockItem.append(window.$('<div><a href="https://www.youtube.com/results?search_query=' + music.artists[0].name + ' ' + music.title + '" target="_blank">Youtube Search</a></div>'));
            musicBlocksList.push(musicBlockItem);
        });

        return fragmentBlock.append(window.$('<ul />').append(musicBlocksList));
    },
    fragmentsList: function (fragments) {
        let detailsList = [];

        fragments.forEach((fragment, index) => {
            if (fragment.response.metadata) {
                let fragmentBlock = window.$('<li style="margin:15px 0 0 0;">');
                fragmentBlock.append(window.$('<h2>Fragment ' + (index + 1) + '</h2>'));
                fragmentBlock.append(this.fragmentDetails(fragment));
                detailsList.push(fragmentBlock);
            }
        });
        return detailsList;
    },

    render: function () {
        this.settings.container.html('');

        this.settings.container
            .append(window.$('<div class="ui-dialog__release-heading">' + this.track_title + '</div>'));

        var fragments = this.data.fragments;
        if (fragments) {
            var fragmentItems = this.fragmentsList(fragments);
            this.settings.container
                .append(window.$('<ul />').append(fragmentItems));
        } else {
            this.settings.container
                .append(window.$('<div>No Track Fragments</div>'));
        }
    },

    refresh: function () {
        if (this.settings.initial) {
            this.onData(this.settings.initial);
            this.settings.initial = null;
        } else {
            const self = this;
            window.$.ajax(this.settings.url, {async: false})
                .done(function (_data) {
                    self.onData(_data);
                });
        }
        if (this.settings.afterUpdate) {
            this.settings.afterUpdate(this);
        }
    },

    show: function () {
        const self = this;
        this.refresh();
        this.render();

        const buttons = [{
            text: _T('close'),
            class: 'ui-button--close',
            click: function () {
                self._closeDialog();
            }
        }];

        this.settings.container.dialog({
            buttons: buttons,
            close: function () {
                self._closeDialog();
            },
            closeText: '',
            dialogClass: setDialogClass('release_preview_errors'),
            draggable: false,
            hide: 'fade',
            minHeight: 386,
            maxHeight: 586,
            modal: true,
            position: {at: 'top+8%', my: 'top+8%'},
            resizable: false,
            title: this.title,
            show: 'fade',
            width: 550,
            zIndex: 100000
        });
    },

    close: function () {
        this._closeDialog();
    },

    _closeDialog: function () {
        enableUserActions();
        this.settings.container.dialog('close');
    },
};
